import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import styles from './styles/hint-content.module.css';
/**
 * `<HintContent />` - Обёртка для наполнения Хинта. Предоставляет стили для контента.
 *
 * @example ``` tsx
 <HintContent header="Your header" paragraph="Your paragraph" >
   <SomeChildComponent />
 </HintContent>
 * ```
 */
export const HintContent = /*#__PURE__*/forwardRef(function HintContent({
  className,
  header,
  paragraph,
  column,
  children,
  ...props
}, ref) {
  const textClassName = clsx(styles.textBlock, {
    [styles.hasChild]: !!children,
    [styles.column]: !!column
  }, className);
  const hasText = useMemo(() => header || paragraph, [header, paragraph]);
  const notEmpty = hasText || children;
  return notEmpty ? (/*#__PURE__*/React.createElement(React.Fragment, null, children, hasText && (/*#__PURE__*/React.createElement("div", {
    className: textClassName,
    ref: ref,
    ...props
  }, header && /*#__PURE__*/React.createElement("p", {
    className: styles.header
  }, header), paragraph && /*#__PURE__*/React.createElement("p", {
    className: styles.paragraph
  }, paragraph))))) : null;
});